import { NavLink } from 'react-router-dom';
import {
  BookMarked,
  BookOpen,
  ClipboardCheck,
  Edit3,
  Home,
  Plug,
  Search,
  Settings,
  Library,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuditoriaStats } from '@/hooks/useAuditoria';

const NAV = [
  { to: '/', label: 'Dashboard', icon: Home },
  { to: '/busca', label: 'Busca', icon: Search },
  { to: '/auditoria', label: 'Auditoria', icon: ClipboardCheck, showBadge: true },
  { to: '/obsidian', label: 'Obsidian & Docs', icon: Library },
  { to: '/cursos', label: 'Cursos & Formações', icon: BookOpen },
  { to: '/glossario', label: 'Glossário', icon: BookMarked },
  { to: '/lousas', label: 'Lousas', icon: Edit3 },
  { to: '/integracoes', label: 'Integrações', icon: Plug },
  { to: '/configuracoes', label: 'Configurações', icon: Settings },
];

export function Sidebar(): JSX.Element {
  const { data: auditoriaStats } = useAuditoriaStats();
  const pendentes = auditoriaStats?.pendentes ?? 0;

  return (
    <aside className="w-56 border-r border-border bg-card flex flex-col">
      <nav className="flex-1 p-2">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 px-3 py-1.5 text-sm rounded-md transition-colors mb-0.5',
                isActive
                  ? 'bg-accent text-foreground font-medium'
                  : 'text-muted-foreground hover:bg-accent hover:text-foreground',
              )
            }
          >
            <item.icon className="h-4 w-4" />
            <span className="flex-1">{item.label}</span>
            {item.showBadge && pendentes > 0 && (
              <span className="h-4 min-w-[16px] rounded-full bg-primary text-[10px] font-medium text-primary-foreground flex items-center justify-center px-1">
                {pendentes > 99 ? '99+' : pendentes}
              </span>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-border text-xs text-muted-foreground">
        Central da Tata · v0.1
      </div>
    </aside>
  );
}
